var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLvtMonochrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146:1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.125 42.655H36.138V44.975H27.695V30.209H30.125V42.655Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.415 44.9731L35.289 30.2061H37.946L41.87 42.04L45.815 30.2061H48.452L43.326 44.9731H40.415Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.633 30.209V32.529H55.478V44.973H53.052V32.529H48.875V30.209H59.633Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6811 45.249C72.513 45.2484 71.3606 44.9807 70.312 44.4662C69.2633 43.9517 68.3463 43.2042 67.631 42.2808C66.9157 41.3574 66.4211 40.2827 66.185 39.1387C65.949 37.9948 65.9777 36.812 66.269 35.6809C66.5603 34.5498 67.1066 33.5003 67.8659 32.6127C68.6252 31.7252 69.5775 31.023 70.6499 30.5601C71.7222 30.0972 72.8863 29.8857 74.053 29.9418C75.2197 29.998 76.3581 30.3203 77.3811 30.884C78.4811 31.4852 79.3965 32.3747 80.0291 33.457L77.9201 34.68C77.5248 33.9479 76.9284 33.3441 76.2011 32.94C75.4322 32.507 74.5624 32.2851 73.6801 32.297C72.9728 32.2687 72.2674 32.3874 71.6083 32.6456C70.9492 32.9038 70.3509 33.2958 69.851 33.797C68.9078 34.8367 68.3853 36.1902 68.3853 37.594C68.3853 38.9978 68.9078 40.3513 69.851 41.391C70.3508 41.8923 70.9492 42.2844 71.6082 42.5426C72.2673 42.8008 72.9728 42.9194 73.6801 42.891C74.5655 42.9019 75.4382 42.6802 76.2111 42.248C76.9405 41.8495 77.5352 41.2437 77.9201 40.507L80.0291 41.707C79.407 42.793 78.4982 43.687 77.4021 44.291C76.267 44.9307 74.9839 45.2611 73.6811 45.249Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 44.9731L90.516 41.998H84.23L83.197 44.9731H80.56L85.918 30.2061H88.829L94.166 44.9731H91.55ZM85.031 39.72H89.714L87.373 33.0541L85.031 39.72Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.191 30.209C101.837 30.1917 102.48 30.3063 103.08 30.5456C103.68 30.785 104.225 31.144 104.682 31.601C105.582 32.526 106.085 33.7653 106.085 35.0555C106.085 36.3457 105.582 37.585 104.682 38.51C104.227 38.9693 103.682 39.3304 103.081 39.5712C102.481 39.812 101.838 39.9273 101.191 39.91H98.175V44.973H95.749V30.209H101.191ZM101.191 37.634C101.521 37.6441 101.849 37.5847 102.154 37.4594C102.46 37.3341 102.735 37.1459 102.963 36.907C103.412 36.3968 103.66 35.7405 103.66 35.061C103.66 34.3814 103.412 33.7251 102.963 33.215C102.736 32.9758 102.46 32.7872 102.155 32.6618C101.849 32.5363 101.521 32.4768 101.191 32.487H98.175V37.634H101.191Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.194 30.209H110.62V44.973H108.194V30.209Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.172 30.209V32.529H119.016V44.973H116.59V32.529H112.413V30.209H123.172Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53 44.9731L132.496 41.998H126.21L125.176 44.9731H122.539L127.897 30.2061H130.808L136.146 44.9731H133.53ZM127.011 39.72H131.694L129.353 33.0541L127.011 39.72Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.153 42.655H146.165V44.975H137.727V30.209H140.153V42.655Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.258 51.953H19V24H153.258V51.953ZM20.158 50.797H152.102V25.156H20.156L20.158 50.797Z",
    fill: "#0C2C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146:1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.257,
    height: 27.953,
    fill: "white",
    transform: "translate(19 24)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvtMonochrome);
export default __webpack_public_path__ + "static/media/lvtMonochrome.a46953d285ca4d1f67b61a75a49ce5e9.svg";
export { ForwardRef as ReactComponent };